import { render, staticRenderFns } from "./SealMaterial.vue?vue&type=template&id=00d9a106&scoped=true"
import script from "./SealMaterial.vue?vue&type=script&lang=js"
export * from "./SealMaterial.vue?vue&type=script&lang=js"
import style0 from "./SealMaterial.vue?vue&type=style&index=0&id=00d9a106&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d9a106",
  null
  
)

export default component.exports